const FromArr = [
    {
        title: "产品线：",
        inputtype: "select",
        inputflag: true,
        fontSize: 14,
        color: "#333333",
        lableheight: 20,
        X: false,
        types: "",
        placeholder: "请选择",
        width: 192,
        height: 32,
        disabled: false,
        marginLeft: 30,
        marginTop: 15,
        displayVal: "inline-block",
        fontWeightVal: 500,
        options: []
      },
]
export default FromArr;